"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderLineStatus = void 0;
var SalesOrderLineStatus;
(function (SalesOrderLineStatus) {
    SalesOrderLineStatus["NEW"] = "new";
    SalesOrderLineStatus["LINE_SUBMITTED"] = "submitted";
    SalesOrderLineStatus["UPDATED"] = "updated";
    SalesOrderLineStatus["CONFIRMED"] = "confirmed";
    SalesOrderLineStatus["PRODUCTION"] = "production";
    SalesOrderLineStatus["CLOSED"] = "closed";
})(SalesOrderLineStatus = exports.SalesOrderLineStatus || (exports.SalesOrderLineStatus = {}));
//# sourceMappingURL=sales-order-line-status.enum.js.map